// Priority display labels and table sorting shared by SafeCurves and SafeIntersections.

export const mapPriorityDisplayLabel: Record<string, string> = {
	'Priority 1': 'Priority 1 (10%)',
	'Priority 2': 'Priority 2 (15%)',
	'Priority 3': 'Priority 3 (20%)',
	'Priority 4': 'Priority 4 (20%)',
	'Priority 5': 'Priority 5 (35%)',
	'Not prioritized': 'Not prioritized'
};

/** Display label for a raw rating via the app's raw-to-description map, falling back to the raw value. */
export const priorityLabel = (descriptions: Record<string, string>, raw: unknown): string => {
	const desc = descriptions[String(raw)];
	return desc ? (mapPriorityDisplayLabel[desc] ?? desc) : String(raw ?? '');
};

type Gettable = { getValue: (columnId: string) => unknown };

/** Table sortFn ordering raw values by domain order (highest priority first) rather than alphabetically. */
export const sortByOrder =
	(order: readonly string[]) => (rowA: Gettable, rowB: Gettable, columnId: string) =>
		order.indexOf(rowA.getValue(columnId) as string) -
		order.indexOf(rowB.getValue(columnId) as string);
